import Vue from 'vue'
import {Mutation, Action, VuexModule, getModule, Module} from "vuex-module-decorators";
import store from "@/store/store";
import {CmsApiClient} from "@/_global/api_clients/CmsApiClient";
import {Util} from "@/_global/utils";


// 言語別の名称情報を保持する


@Module({
    name: "CondimentGroupsStore",
    dynamic: true,
    store: store,
    namespaced: true
})
class CondimentGroupsStore extends VuexModule {
    // state
    private _apiResponse: CMS.CondimentGroup[] = [];
    private _condimentGroupById: { [id: number]: CMS.CondimentGroup } = {};

    private apiBackup: CMS.CondimentGroup[] = [];
    private edited: { [itemId: number]: CMS.CondimentGroup } = {};

    // getter
    get all(): CMS.CondimentGroup[] {
        return this._apiResponse || [];
    }

    get condimentGroupById(): { [id: number]: CMS.CondimentGroup } {
        return this._condimentGroupById;
    }

    get dirty(): boolean {
        return Object.keys(this.edited).length > 0;
    }

    @Action
    public async init() {
        const response: CMS.CondimentGroup[] = await CmsApiClient.getCondimentGroups();
        this.refresh(response);
    }

    @Action
    private refresh(response: CMS.CondimentGroup[]) {
        this.initVals();
        this.setResponse(response);
        for (let i = 0; i < response.length; i++) {
            this.setCondimentGroupById(response[i]);
        }
    }

    @Mutation
    private initVals() {
        this._apiResponse = [];
        this._condimentGroupById = {};
        this.edited = {};
    }

    @Mutation
    private setResponse(response: CMS.CondimentGroup[]) {
        this._apiResponse = response;
        this.apiBackup = Util.deepCopy(this._apiResponse); //復元用にdeep copyでバックアップ
    }

    @Mutation
    private setCondimentGroupById(condimentGroup: CMS.CondimentGroup) {
        Vue.set(this._condimentGroupById, condimentGroup.condiment_group_id, condimentGroup);
    }

    @Action
    public async create(condimentGroup: CMS.CondimentGroup) {
        await CmsApiClient.setCondimentGroup(condimentGroup);
        this.init();
    }


    @Mutation
    public localEdit(condimentGroup: CMS.CondimentGroup) {
        if (!this._condimentGroupById[condimentGroup.condiment_group_id])
            return;

        Vue.set(this._condimentGroupById, condimentGroup.condiment_group_id, condimentGroup);
        Vue.set(this.edited, condimentGroup.condiment_group_id, condimentGroup);
    }

    @Action
    public async cancelEdit() {
        this.refresh(this.apiBackup);
    }

    @Action
    public async applyEdit() {
        if (!this.dirty)
            return;

        for (const condimentGroupId in this.edited) {
            await CmsApiClient.setCondimentGroup(this.edited[condimentGroupId]);
        }
        this.init();
    }
}

export default getModule(CondimentGroupsStore);
